import styled from 'styled-components';
import { device } from 'modules/Utils/Devices';

export const Placeholder = styled.div`
  padding: 3rem;

  @media ${device.tablet} {
    width: 100%;
    border-right: 0;
    border-bottom: 0.1rem solid ${(props) => props.theme.config.colors.gray_200};
  }
`;

export const PlaceholderItem = styled.div`
  width: 10rem;
  margin-bottom: 0.8rem;

  span {
    height: 2.4rem;
    border-radius: 0.6rem;
  }
`;

export const FlexList = styled.div`
  display: flex;

  svg {
    margin: 0 0.4rem;
    width: 0.8rem;

    path {
      fill: ${(props) => props.theme.config.colors.gray_300};
    }
  }

  @media ${device.tabletAndMobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;

    svg {
      display: none;
    }
  }
`;

export const Span = styled.span`
  ${(props) => props.theme.config.typograph.mico};
  color: ${(props) => props.theme.config.colors.text_base};
  display: inline-block;
`;

export const Title = styled.p`
  ${(props) => props.theme.config.typograph.mico};
  font-weight: bold;
  color: ${(props) => props.theme.config.colors.text_base};
  display: inline-block;
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;
